import type { DocsService } from '@affine/core/modules/doc';
import { Service } from '@toeverything/infra';
import { map, type Observable } from 'rxjs';

import { startSortKey } from '../../../../components/workspace-property-types/date-value';
import type { OrderByProvider } from '../../provider';
import type { OrderByParams } from '../../types';

export class DatePropertyOrderByProvider
  extends Service
  implements OrderByProvider
{
  constructor(private readonly docsService: DocsService) {
    super();
  }
  orderBy$(
    _items$: Observable<Set<string>>,
    params: OrderByParams
  ): Observable<string[]> {
    const isDesc = params.desc;
    return this.docsService.propertyValues$('custom:' + params.key).pipe(
      map(o => {
        return Array.from(o)
          .filter((i): i is [string, string] => !!i[1]) // filter empty value
          .map((i): [string, string, string] => [
            i[0],
            i[1],
            startSortKey(String(i[1])) || String(i[1]),
          ])
          .sort((a, b) => {
            const valA = a[2];
            const valB = b[2];
            return (
              (valA === valB ? 0 : valA > valB ? 1 : -1) * (isDesc ? -1 : 1)
            );
          })
          .map(i => i[0]);
      })
    );
  }
}
